/**
 * Replicates Liquid `handleize` filter
 * @see https://github.com/Shopify/liquid/blob/63eb1aac69a31d97e343822b973b3a51941c8ac2/performance/shopify/shop_filter.rb#L100
 * @param {string} string
 */
const handleize = string => {
  /**
   * 1. Convert string to lowercase
   * 2. Remove '/"()[] characters
   * 3. Replace remaining non-word characters with hyphens
   * 4. Remove hyphens from each end of the string
   */
  return String(string)
    .toLowerCase()
    .replace(/['"()[\]]/g, '')
    .replace(/\W+/g, '-')
    .replace(/^-|-$/g, '');
};

export default handleize;
